module.exports = __webpack_public_path__ + "static/img/Round-06-2008.4bb44e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-06-2008.jpg
// module id = /+nu
// module chunks = 0